import { Box, useMediaQuery, useTheme } from "@mui/material";

export function AnuncioGrid({ children }: { children: React.ReactNode }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Box
      display="grid"
      gridTemplateColumns={
        isMobile ? "repeat(auto-fill, minmax(280px, 1fr))" : "repeat(3, 1fr)"
      }
      gap={isMobile ? 2 : 3}
      justifyItems={isMobile ? "center" : "stretch"}
      alignItems="start"
    >
      {children}
    </Box>
  );
}
